import { z } from 'zod'

export const AiTemplateTypeSchema = z.enum([
  'SINGLE_PORTRAIT',
  'WALL_SQUARE',
  'WALL_SQUARE_SIX',
  'MULTI_INPUT_DYNAMIC_WALL',
  'MULTI_INPUT_DYNAMIC_WALL_12x16',
  'MULTI_INPUT_DYNAMIC_WALL_20x27',
  'SINGLE_INPUT_DYNAMIC_WALL_12x16',
  'SINGLE_INPUT_DYNAMIC_WALL_20x27',
  'FORM_INPUT_DYNAMIC_WALL',
  'PHOTO_BOOK_COVER',
])
export type AiTemplateType = z.infer<typeof AiTemplateTypeSchema>
